import "./index.scss";

import DateFnsUtils from "@date-io/date-fns";
import CssBaseline from "@material-ui/core/CssBaseline";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import React from "react";
import ReactDOM from "react-dom";
import { queryCache, ReactQueryConfigProvider, ReactQueryProviderConfig } from "react-query";
import { ReactQueryDevtools } from "react-query-devtools";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

import { QUERY_KEYS } from "./app/constants";
import { Main } from "./app/main";
import { store } from "./app/redux/store";
import * as serviceWorker from "./serviceWorker";

const config: ReactQueryProviderConfig = {
  refetchOnWindowFocus: false,
  retry: false,
  onError: (err: any) => {
    if (err.response.status === 401) {
      queryCache.refetchQueries(QUERY_KEYS.isLoggedIn);
    }
  },
};

ReactDOM.render(
  <MuiPickersUtilsProvider utils={DateFnsUtils}>
    <Provider store={store}>
      <BrowserRouter>
        <ReactQueryConfigProvider config={config}>
          <CssBaseline />
          <ReactQueryDevtools />
          <Main />
        </ReactQueryConfigProvider>
      </BrowserRouter>
    </Provider>
  </MuiPickersUtilsProvider>,
  document.getElementById("root"),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
